<template>
  <div class="columns is-multiline">
    <div class="column is-half">
      <!-- 저장 -->
      <div class="btn-group-justify-end">
        <button class="button is-primary" @click="saveData">저장하기</button>
      </div>

      <div class="box">
        <admin-box-item title="공지사항 게시글 등록/수정">
          <div class="columns is-multiline">
            <div class="column is-full">
              <!-- 그룹 드롭다운 리스트 선택 -->
              <admin-form-item label="*팀 선택">
                <div v-if="param_group_id!==''">{{ selectedGroup }}</div>
                <lp-adm-drop-input ref="adminput"
                                   :data.sync="groupList"
                                   :selectVal="selectedGroup"
                                   @onSelect="res => group_id=res.value"
                                   placeholder="팀 선택"
                                   width="160px"
                                   listAlign="center"
                                   style="display:inline-block; margin-right:4px;" v-else></lp-adm-drop-input>
              </admin-form-item>
            </div>
            <div class="column is-full" v-if="catList&&catList.length>0">
              <!-- 그룹 공지 카테고리 드롭다운 리스트 선택 -->
              <admin-form-item label="*카테고리 선택">
                <lp-adm-drop-input ref="adminput"
                                  :data.sync="catList"
                                  :selectVal="selectedCat"
                                  @onSelect="res => notice.category=res.value"
                                  placeholder="카테고리 선택"
                                  width="160px"
                                  listAlign="center"
                                  style="display:inline-block; margin-right:4px;"
                                  ></lp-adm-drop-input>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="공지사항 게시글 노출기간">
                <div class="flex" style="flex-wrap:wrap">
                  <admin-date-picker
                    :data="notice.start_date"
                    @setDate="selDateMin"></admin-date-picker>
                  <div class="lp-dating">&#126;</div>
                  <admin-date-picker
                    :data="notice.end_date"
                    @setDate="selDateMax"></admin-date-picker>
                </div>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="노출 우선순위">
                <input class="input"
                       :value="notice.priority"
                       @input="e => notice.priority = e.target.value"
                       placeholder="노출 우선순위를 입력하세요. (0~99)"
                       type="text">
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="제목*">
                <input class="input"
                       :value="notice.title"
                       @input="e => notice.title = e.target.value"
                       placeholder="제목을 입력하세요."
                       type="text">
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="내용*">
                <lp-editor :text.sync="notice.content"></lp-editor>
              </admin-form-item>
            </div>
          </div>
        </admin-box-item>
      </div>

      <!-- 저장 -->
      <div class="btn-group-justify-end">
        <button class="button is-primary" @click="saveData">저장하기</button>
      </div>
    </div>
  </div>
</template>
<script>
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import AdminDatePicker from "../../../module/admin/AdminDatePicker";
  import GroupMixin from "@/mixins/GroupMixin"
  import CreateMixin from "@/mixins/CreateMixin"

  export default {
    name: 'NoticeCreate',
    mixins: [
      GroupMixin,
      CreateMixin
    ],
    components: {AdminDatePicker,LpAdmDropInput},
    data() {
      return {
        group_id: 0,
        groupList: [],
        catList: [],
        notice: {
          id: 0,
          start_date: '',
          end_date: '',
          priority: 0,
          title: '',
          content: ''
        }
      }
    },
    created() {
      this.getData();
    },
    computed: {
      selectedGroup() {
        let label = '';
        this.groupList.forEach(item=>{
          if(item.value===this.group_id) {
            label = item.label;
          }
        })
        return label;
      },
      selectedCat() {
        let label = '';
        this.catList.forEach(item=>{
          if(item.value===this.notice.category) {
            label = item.label;
          }
        })
        return label;
      },
    },
    watch: {
      $route() {
        this.getData();
      }
    },
    methods: {
      getData() {
        this.getGroupList('groupList', true);
        this.notice = {
          id: 0,
          start_date: '',
          end_date: '',
          priority: 0,
          title: '',
          content: ''
        };
        let notice_id = this.$route.query.notice_id;
        if(this.$route.query.notice_id) {
          this.notice.start_date = this.convertNewDate(this.notice.start_date);
          this.notice.end_date = this.convertNewDate(this.notice.end_date);
        }

        this.group_id = this.$route.query.group_id ? parseInt(this.$route.query.group_id) : '';
        if(this.group_id === '')
          this.group_id = this.param_group_id;

        if(notice_id) {
          this.$axios.get(this.getUrl(`group/${this.group_id}/notice/${notice_id}`)).then(res=>{
            this.notice = res.data;
          })
        }

        // 공지사항 카테고리 목록 불러오기
        this.getNoticeCategory();
      },
      getNoticeCategory() {
        this.$axios.get('public/group/notice_category')
        .then(res => {
          this.catList = res.data;
        })
      },
      selDateMin(val) {
        this.notice.start_date = val;
      },
      selDateMax(val) {
        this.notice.end_date = val;
      },
      saveData() {
        let notice_id = this.$route.query.notice_id;
        let group_id = this.$route.query.group_id;
        /*if(this.group_id===0 || this.group_id==='') {
          this.toast('팀을 선택하세요.');
          return;
        }*/
        let err = '';
        if ( !this.notice.title ) err = '제목을 입력하세요.';
        else if( !this.notice.content ) err= '내용을 입력하세요.';

        if ( err ) {
          this.toast(err);
          return;
        }

        let value = this.cloneItem(this.notice);
        if(!value.start_date){
          value.start_date = '1111-01-01';
        }
        if(!value.end_date){
          value.end_date = '9999-01-01';
        }

        // 전체 공지일 경우
        if(this.group_id==='') {
          if(notice_id){
            this.$axios.patch(this.getUrl(`group/notice/${notice_id}`), value).then(res=>{
              if(res.status===200){
                this.toast('저장되었습니다.');
                this.$router.replace(this.getPath('group/notice'));
              }
            })
          }
          else {
            this.$axios.post(this.getUrl(`group/${this.group_id}/notice`), value).then(res=>{
              if(res.status===200){
                this.toast('저장되었습니다.');
                this.$router.replace(this.getPath('group/notice'));
              }
            })
          }
        }

        // 선택한 그룹이 있을 경우
        else {
          if(notice_id){
            this.$axios.patch(this.getUrl(`group/${group_id}/notice/${notice_id}`), value).then(res=>{
              if(res.status===200){
                this.toast('저장되었습니다.');
                this.$router.replace(this.getPath('group/notice'));
              }
            })
          }
          else {
            this.$axios.post(this.getUrl(`group/${this.group_id}/notice`), value).then(res=>{
              if(res.status===200){
                this.toast('저장되었습니다.');
                this.$router.replace(this.getPath('group/notice'));
              }
            })
          }
        }
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
